import React from 'react'
import Loading from '../Loading/Loading'

import './Btn.css'
export default function Btn({
  children,
  onClick,
  disabled = false,
  isLoading = false,
  backgroundColor = '#14B0BF',
  style
}) {
  const classes = disabled ? 'Btn Btn-disabled' : 'Btn'
  return isLoading ? (
    <div style={{ display: 'inline-block', textAlign: 'center' }}>
      <Loading size="xs" />
    </div>
  ) : (
    <button className={classes} style={{ backgroundColor, ...style }} type="button" onClick={onClick}>
      {children}
    </button>
  )
}
